
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component
export default class TheStatus extends Vue {
  @Prop() item!: any;
}
